import React from "react";
import { Box, Grid, Container } from "@mui/material";
import { motion } from "framer-motion";
import jsw from "../assets/jsw.jpg"
import tata from "../assets/tata.jpg"
import birla from "../assets/birla.jpg"
import eldeco from "../assets/eldeco.jpg"
import migsun from "../assets/migsun.jpg"
import omaxe from "../assets/omaxe.jpg"

const partnerLogos = [
  jsw,
  tata,
  birla,
  eldeco,
  migsun,
  omaxe
];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: {
    opacity: 0,
    x: 40, // start from right
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut",
    },
  },
};
const CompanyPartner = () => {
  return (
    <Box
      sx={{
        py: 8,
        backgroundColor: "#eceff3", // light grey background like screenshot
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="lg">
        <Grid
          container
          spacing={4}
          justifyContent="space-between"
          component={motion.div}
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {partnerLogos.map((logo, i) => (
            <Grid
              item
              size={{ xs: 6, sm: 4, md: 2 }}
              key={i}
              textAlign="center"
              component={motion.div}
              variants={itemVariants}
            >
              <Box
                component="img"
                src={logo}
                alt="Partner Logo"
                sx={{
                  width: 130,
                  height: "auto",
                  opacity: 0.8,
                  transition: "0.3s",
                  cursor: "pointer",
                  "&:hover": {
                    opacity: 1,
                    transform: "scale(1.05)",
                  },
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CompanyPartner;
